module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-genova.svg?f86f75a3ed16c1be4a2d48a4fd6c05ec";